;(function () {
  'use strict'

  angular
    .module('contrast.reset-apps')
    .factory('csResetAppsService', [
      '$rootScope',
      '$translate',
      'ApplicationFactory',
      'dialogs',
      'csTemplates',
      csResetAppsService
    ])

  function csResetAppsService(
    $rootScope,
    $translate,
    ApplicationFactory,
    dialogs,
    csTemplates
  ) {
    var tpls = {
      resetOneApp: 'views/applications/reset_one_app.html'
    }

    var service = {
      resetOneApp: resetOneApp
    }

    return service

    function resetOneApp(app) {
      var transl = {
        title_resetAppConfirmation: $translate.instant(
          'title_resetAppConfirmation'
        ),
        action_applications_reset_application: $translate.instant(
          'action_applications_reset_application'
        ),
        action_cancel: $translate.instant('action_cancel')
      }

      return csTemplates
        .loadAndInterpolate(tpls.resetOneApp, { appName: app.name })
        .then(function (interpolatedStr) {
          return dialogs.confirm(
            transl.title_resetAppConfirmation,
            interpolatedStr,
            {
              size: 'md',
              yes: transl.action_applications_reset_application,
              no: transl.action_cancel
            }
          ).result
        })
        .then(function () {
          // Confirmed, reset it
          return ApplicationFactory.resetBatch([app])
        })
        .then(function () {
          $rootScope.$broadcast('app:update')
        })
    }
  }
})()
